// Service d'authentification locale pour le développement
interface User {
  id: string;
  email: string;
  password: string;
  displayName: string;
  emailVerified: boolean;
}

// Base de données locale simulée
const localUsers: User[] = [
  {
    id: '1',
    email: 'test@example.com',
    password: 'password123',
    displayName: 'Test User',
    emailVerified: true
  },
  {
    id: '2',
    email: 'admin@allure.com',
    password: 'admin123',
    displayName: 'Admin Allure',
    emailVerified: true
  }
];

// Stockage local pour la session
const SESSION_KEY = 'allure_user_session';

export const localAuth = {
  // Connexion
  signIn: async (email: string, password: string) => {
    const user = localUsers.find(u => u.email === email && u.password === password);
    if (user) {
      // Sauvegarde de la session
      localStorage.setItem(SESSION_KEY, JSON.stringify({
        id: user.id,
        email: user.email,
        displayName: user.displayName,
        emailVerified: user.emailVerified
      }));
      return { user: { ...user, password: undefined } };
    }
    throw new Error('Email ou mot de passe incorrect');
  },

  // Déconnexion
  signOut: async () => {
    localStorage.removeItem(SESSION_KEY);
  },

  // Vérification de la session
  getCurrentUser: () => {
    const session = localStorage.getItem(SESSION_KEY);
    return session ? JSON.parse(session) : null;
  },

  // Réinitialisation de mot de passe
  resetPassword: async (email: string) => {
    const user = localUsers.find(u => u.email === email);
    if (user) {
      // En mode développement, on affiche le mot de passe dans la console
      console.log(`🔑 Mot de passe pour ${email}: ${user.password}`);
      return true;
    }
    throw new Error('Email non trouvé');
  },

  // Changement de mot de passe
  changePassword: async (email: string, currentPassword: string, newPassword: string) => {
    const userIndex = localUsers.findIndex(u => u.email === email && u.password === currentPassword);
    if (userIndex !== -1) {
      localUsers[userIndex].password = newPassword;
      console.log(`✅ Mot de passe changé pour ${email}`);
      return true;
    }
    throw new Error('Mot de passe actuel incorrect');
  },

  // Inscription
  signUp: async (email: string, password: string, displayName: string) => {
    const existingUser = localUsers.find(u => u.email === email);
    if (existingUser) {
      throw new Error('Un compte avec cet email existe déjà');
    }
    
    const newUser: User = {
      id: Date.now().toString(),
      email,
      password,
      displayName,
      emailVerified: false
    };
    
    localUsers.push(newUser);
    console.log(`✅ Nouveau compte créé pour ${email}`);
    return { user: { ...newUser, password: undefined } };
  }
};
